import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Conteúdo Curricular',
    path: '/academico/parametros/conteudocurricular',
    name: 'conteudocurricular',
    component: () => import('@/views/academico/parametros/conteudocurricular/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.CONTEUDOSCURRICULARESNOVO_MENU_300900499],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Conteúdo Curricular',
    path: '/academico/parametros/conteudocurricular/cadastro/:id?',
    parent: 'conteudocurricular',
    name: 'conteudocurricular_create',
    component: () => import('@/views/academico/parametros/conteudocurricular/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.CONTEUDOSCURRICULARESNOVO_MENU_300900499],
    },
  },
]

